import { useSelector } from 'react-redux';
import { IAppState } from 'config/redux/reducers';

const usePageLoader = () => {
  return [useSelector(({ pageLoader }: IAppState) => pageLoader)];
};

export default usePageLoader;
